class ConsumersController {
    constructor(message, $http, AppConfig,$translate,$filter) {

        "ngInject";
        this.message = message;
        this.$http = $http;
        this.AppConfig = AppConfig;
        this.$translate=$translate;
        this.tranlsteFilter=$filter('translate');
        this.tags = [
            'face-consumers-text022',
            'face-consumers-text023',
            'face-consumers-text024',
            'face-consumers-text025',
            'face-consumers-text026',
            'face-consumers-text027',
            'face-consumers-text028',
            'face-consumers-text029',
            'face-consumers-text030',
            'face-consumers-text031',
            'face-consumers-text033',
            'face-consumers-text034',
            'face-consumers-text035',
            'face-consumers-text036',
            'face-consumers-text037'
        ];

        this.otherTags = '';

        this.selected = [];

        this.frame = 'tags';

        this.loading = false;
        this.errors = {};
    }

    toggleSelect(tag) {

        let idx = this.selected.indexOf(tag);

        if(idx == -1)
        {
            this.selected.push(tag);
        }else{
            this.selected.splice(idx, 1);
        }
    }

    next() {
        if(this.selected.length == 0 && this.otherTags == '')
        {
            this.$translate('face-consumers-text016').then((translation) =>{
                this.message.error(translation);
            });
            return;
        }

        this.frame = 'info';
    }

    back() {
        this.frame = 'tags';
    }

    subscribe() {

        this.errors = {};
        let hasError = false;
        let required = ['email', 'phone', 'company'];

        for(let i=0; i<required.length; i++)
        {
            let r = required[i];
            let v = $('#' + r).val();

            if(v === '')
            {
                this.$translate('face-consumers-text021').then((translation) =>{
                    this.errors[r] = translation + $('#' + r).attr('data-name');
                });
                hasError = true;
            }
            if(r=='email'){
                var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
                if(v!=='' && !reg.test(v)){
                    this.$translate('face-consumers-text020').then((translation) =>{
                        this.errors[r] = $('#' + r).attr('data-name')+translation;
                    });
                    hasError = true;
                }
            }
        }

        if(hasError)
            return;

        let email = $('#email').val();
        let phone = $('#phone').val();
        let company = $('#company').val();

        this.loading = true;


        let self = this;

        this.$http.post(self.AppConfig.server_url + '/subscribe', {
            'email': email,
            'phone': phone,
            'company': company,
            'tags': self.selected.join(',') + (self.otherTags == '' ? '' : ',' + self.otherTags)
        }, {
            withCredentials: true
        }).then(
            () => {
                this.loading = false;
                self.frame = 'success';
            },
            (response) => {
                this.loading = false;

                if(response.data)
                {
                    for (let field in response.data) {
                        if (response.data.hasOwnProperty(field)) {
                            self.errors[field] = response.data[field][0];
                        }
                    }
                }
            }
        );
    }

    done() {
        this.frame = 'tags';
    }
}

export default ConsumersController;



// WEBPACK FOOTER //
// ./src/app/components/face/consumers/consumers.controller.js